function getId(obj) {
    if (obj) {
      return obj.id
    }
  }
  
  const infosGerais = () => ({
    idPropostaStatus: null,
    idTipoDeProposta:null,
    idPropostaTipo: null,
    idApoliceModalidade: null,
    idParcelamento: null,
    dataPrimeiraParcela: null,
    idFormaPagamento: null,
    proponenteRazaoSocial: null,
    proponenteCnpj: null,
    cepPernoite: null,
    idProponenteRamoDeAtuacao: null,
    enderecoCep: null,
    enderecoRua: null,
    enderecoNumero: null,
    enderecoComplemento: null,
    enderecoBairro: null,
    idEnderecoUf: null,
    enderecoCidade: null,
    enderecoTelefone: null,
    idTipoPessoa: null,
    enderecoEmail: null,
    apoliceIof: null,
    apolicePercSinistro: null,
    corretagem: null,
    dateInicio: null,
    dateFim: null,
    participanteList: null,
    percCondicaoComercial: null,
    idUsuarioCorretor: null, 
    nomeUsuarioCorretor: null,
    informarNomeSocial: null, 
    nomeSocial: null
  })
  
  const dadosCorretorReserva = () => ({
    dataVencimentoApolice: null,
    cnpj: null,
    idCiaRenovacao: null,
    idPropostaTipo: null,
    descricao: null,
    razaoSocial: null,
    detentorApolice: null,
    idStatusCorretorReserva: null,
    idTipoPessoa: null,
    idTipoDeProposta: null,
  })
  
  const riscos = () => ({
    idRiscoCargasEventuaisList: null,
    idRiscoFormaGerenciamentoList: null,
    idRiscoGerenciamento: null,
    idRiscoDirecaoDefensiva: null,
    idRiscoLimitadorVelocidade: null,
    idRiscoIdentificacaoVisual: null,
    idRiscoReclamacoes: null,
    idRiscoPermanenciaVeiculoForaList: null,
    idRiscoRegiaoCirculacaoList: null,
    idRiscoSegmentoAtuacaoList: null,
    idRiscoSegmentoEmbarcadorList: null,
    riscoSinistro: null,
    riscoBonsMotoristas: null,
    riscoMausMotoristas: null,
    riscoVeiculoFuncionario: null,
    riscoSeguroCarga: null,
    riscoTrafegamEstados: null,
    informacoesComplementares: null,
  })
  
  const totaisCotacao = () => ({
    totalAp: null,
    totalCoberturaCompensativa: null,
    totalCoberturaRcf: null,
    totalCoberturasAdicionais: null,
    totalFranquiaCoberturaAcessorios: null,
    totalFranquiaCoberturaCarroceria: null,
    totalFranquiaCoberturaCompensativa: null,
    totalFranquiaCoberturaEquipamentos: null,
    totalPremio: null,
    totalPremioLiquido: null,
    totalServicosAgregados: null,
  })
  
  
  const inicial = () => ({
    // planilha importada
    conteudoPlanilha: [],
    erroPlanilha: [],
    id: null,
    versao: null,
    apoliceNumeroProposta: null,
    apoliceNumero: null,
  
    ...infosGerais(),
  
    ...dadosCorretorReserva(),
  
    ...riscos(),
  
    ...totaisCotacao()
  })
  
  const state = {
    ...inicial()
  }
  
  const mutations = {
    setConteudoPlanilha(state, { dados }) {
      if (dados instanceof Array) {
        state.conteudoPlanilha = dados;
      }
    },
  
    setErroPlanilha(state, { dados }) {
      if (dados instanceof Array) {
        state.erroPlanilha = dados;
      }
    },
  
    setInfoGerais(state, objetoInfoGerais) {
      Object.keys(infosGerais()).forEach(key => {
        state[key] = objetoInfoGerais[key];
      })
    },
  
    setRisco(state, objetoRisco) {
      Object.keys(riscos()).forEach(key => {
        state[key] = objetoRisco[key];
      })
    },
  
    setDadosCorretorReserva(state, objetoDadosCorretorReserva) {
      Object.keys(dadosCorretorReserva()).forEach(key => {
        state[key] = objetoDadosCorretorReserva[key];
      })
    },
  
    limparTudo(state) {
      Object.entries(inicial()).forEach(([key, value]) => {
        state[key] = value;
      })
    },
  
    setDadosApolice(state, objetoDadosApolice) {
      Object.keys(inicial()).forEach(key => {
        state[key] = objetoDadosApolice[key];
      })
      Object.keys(totaisCotacao()).forEach(key => {
        state[key] = objetoDadosApolice.totaisCotacao[key];
      })
      state.conteudoPlanilha = objetoDadosApolice.itemCotacaoList;
      Object.keys(inicial()).filter(key => key.match(/^id[A-Z]/)).forEach(key => {
        const newKey = `${key.charAt(2).toLowerCase()}${key.slice(3)}`
        state[key] = key.match(/.*List$/) && objetoDadosApolice[newKey] instanceof Array ? objetoDadosApolice[newKey].map(item => getId(item)) : getId(objetoDadosApolice[newKey])
      })
  
    },

    limparTudo(state) {
      Object.entries(inicial()).forEach(([key, value]) => {
        state[key] = value;
      });
    }
  }
  
  const getters = {
    conteudoPlanilhaValido(state) {
      return state.conteudoPlanilha instanceof Array && !!state.conteudoPlanilha.length
    },
  
    quantidadeItem(state) {
      return state.conteudoPlanilha.length
    },
  
    conteudoInfoGeraisValido(state, getters) {
      return getters.conteudoPlanilhaValido;
    },
  
    conteudoRiscosValido(state, getters) {
      return getters.conteudoInfoGeraisValido && Object.keys(riscos()).filter((key) => key !== 'informacoesComplementares').every(key => (state[key] !== null && state[key] !== undefined) || (state[key] instanceof Array && state[key].length))
    },
  
    cloneConteudoPlanilha(state) {
      try {
        return JSON.parse(JSON.stringify(state.conteudoPlanilha))
      } catch (error) {
        return [];
      }
    },
    cloneErroPlanilha(state) {
      try {
        return JSON.parse(JSON.stringify(state.erroPlanilha))
      } catch (error) {
        return [];
      }
    },
    conteudoCalculoPlanilha(state) {
      return Object.fromEntries(Object.entries(state).filter(([nome]) => nome.match(/^((r|idR|idsR)isco.*|conteudoPlanilha|apoliceIof|corretagem|percCondicaoComercial)/)))
    },
    conteudoSalvarCotacao(state) {
      const { erroPlanilha, ...cotacao } = state;
      return cotacao;
    },
  
    dadosCorretorReserva(state) {
      return Object.fromEntries(Object.keys(dadosCorretorReserva()).map(key => [key, state[key]]))
    },
  
    infoGerais(state) {
      return { ...Object.fromEntries(Object.keys(infosGerais()).map(key => [key, state[key]])), totalPremio: state.totalPremio, apoliceNumero: state.apoliceNumero, apoliceNumeroProposta: state.apoliceNumeroProposta }
    },
  
    risco(state) {
      return Object.fromEntries(Object.keys(riscos()).map(key => [key, state[key]]))
    },
    totais(state) {
      return Object.fromEntries(Object.keys(totaisCotacao()).map(key => [key, state[key]]))
    }
  
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    getters
  };
  


// WEBPACK FOOTER //
// ./src/store/modules/formCorretorReserva.js